<template>
  <div class="wallet-currency-selector">
    <form-input-display
      v-click-outside="() => (isOpenBalanceSelector ? (isOpenBalanceSelector = false) : null)"
      :isMobile="isMobile"
      :is-open="isOpenBalanceSelector"
      :label="getContent(fieldsSettings, defaultLocaleFieldsSettings, 'fieldsControls.balance.label')"
      :value="balanceObject?.value || ''"
      :img-url="balanceObject?.mask"
      :list-width="listWidth"
      @click-selector="toggleBalanceSelector"
    >
      <!-- Десктоп версия -->
      <template v-if="!isMobile" #header>
        <form-input-search
          class="header"
          v-model:value="searchCurrency"
          :placeholder="getContent(fieldsSettings, defaultLocaleFieldsSettings, 'fieldsControls.search.label')"
        />
      </template>
      <list-simple
        v-if="!isMobile"
        v-model:value="currentCurrencyId"
        :searchValue="searchCurrency"
        :list="filteredCurrencyList || []"
        @selected="selectCurrency"
      />
    </form-input-display>

    <!-- Мобильный bottom sheet -->
    <layout-bottom-sheet v-if="isMobile" ref="balanceSelector" @closed="isOpenBalanceSelector = false">
      <template #header>
        <span class="title">
          {{ getContent(layoutData, defaultLocaleLayoutData, 'header.balance.tabs.coins') }}
        </span>
        <form-input-search
          class="header"
          v-model:value="searchCurrency"
          :placeholder="getContent(fieldsSettings, defaultLocaleFieldsSettings, 'fieldsControls.search.label')"
        />
      </template>

      <list-simple
        v-model:value="currentCurrencyId"
        :searchValue="searchCurrency"
        :list="filteredCurrencyList || []"
        @selected="selectCurrency"
      />

      <template #footer>
        <button-base type="gray" size="sm" @click="toggleBalanceSelector('close')">
          {{ getContent(layoutData, defaultLocaleLayoutData, 'buttons.close') }}
        </button-base>
      </template>
    </layout-bottom-sheet>
  </div>
</template>

<script setup lang="ts">
  interface IBalanceObject {
    value?: string;
    mask?: string;
  }

  interface Props {
    balanceObject?: IBalanceObject;
    filteredCurrencyList: any[];
    listWidth?: string;
  }

  defineProps<Props>();

  const emit = defineEmits<{
    selectCurrency: [accountId: string];
  }>();

  const searchCurrency = ref('');
  const balanceSelector = ref();
  const isOpenBalanceSelector = ref(false);
  const currentCurrencyId = defineModel<string>('currentCurrencyId', {
    default: () => '',
  });

  const { isMobile } = storeToRefs(useDeviceStore());
  const { fieldsSettings, defaultLocaleFieldsSettings, layoutData, defaultLocaleLayoutData } =
    storeToRefs(useGlobalStore());
  const { getContent } = useProjectMethods();

  const toggleBalanceSelector = (action?: 'open' | 'close') => {
    if (isMobile.value) {
      if (action === 'close') {
        balanceSelector.value.close();
      } else {
        balanceSelector.value.open();
      }
    } else {
      isOpenBalanceSelector.value = !isOpenBalanceSelector.value;
    }

    if (action === 'close' || !isOpenBalanceSelector.value) {
      searchCurrency.value = '';
    }
  };

  const selectCurrency = async (accountId: string) => {
    toggleBalanceSelector('close');
    emit('selectCurrency', accountId);
  };
</script>
